import { CSSProperties } from "@material-ui/core/styles/withStyles";
import { container as loginContainer } from "@components/chrome-login/ChromeLogin.styles";
export { content } from "@components/chrome-login/ChromeLogin.styles";
import { greys } from "@clockwise/web-commons/src/styles/color.styles";

const container: CSSProperties = {
  ...loginContainer,
  padding: "10px 0",
};

const icon: CSSProperties = {
  color: greys.white,
  marginBottom: 2,
  marginLeft: 10,
};

const label: CSSProperties = {};

export const styles = {
  container,
  label,
  icon,
};
